/**
 * Base product editor unification — the shell's brain.
 *
 * The long term goal is one editor for every base product: a forced wizard on
 * create, free navigation on edit, with the visible sections chosen by the
 * product's category. The single decision that flow is built around is which
 * editor a given blank belongs to, derived from its resolved print category
 * (the production driven classifier), never a hardcoded type list.
 *
 * Phase 1 lands this decision and the feature flag, inert: nothing renders the
 * shell yet, and `blankEditor.unified` is off, so live behavior is unchanged.
 * Later phases render the shell behind the flag, print categories first and
 * apparel last, each proven on a preview before the next.
 */
import { isRiverrPrintBlank } from "../../helpers/blankSettingsNav";

export const UNIFIED_BLANK_EDITOR_FLAG = "blankEditor.unified";

/**
 * Which editor a blank uses.
 * - "print": paper print, stickers and labels, DTF (the print wizard sections)
 * - "generic": apparel and 3D (the existing tabbed settings)
 */
export function chooseBlankEditor(blankProduct) {
  return isRiverrPrintBlank(blankProduct) ? "print" : "generic";
}

/** Whether the unified editor shell should take over, from the resolved flags. */
export function unifiedBlankEditorEnabled(flags) {
  return !!(flags && flags[UNIFIED_BLANK_EDITOR_FLAG]);
}
